import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { getStorefrontRoute } from '../../utils/urls';
import { useRouteOfferingType } from '../../common/hooks/useRouteOfferingType';

const NoAccessError = () => {
  const offeringType = useRouteOfferingType();
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "keys",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.error.noAccess.title"
    }),
    type: "403",
    children: /*#__PURE__*/_jsx(UIRouterNavButton, {
      className: "m-top-4",
      exact: true,
      to: getStorefrontRoute(offeringType),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.error.noAccess.button"
      })
    })
  });
};

export default NoAccessError;